import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';

import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';

import ProxyBidsHome from '../../../components/Dashboard/ProxyBids/ProxyBidsHome';
import { dashboardBreadcrumb } from '../../../data/routes';

const AdminLayout = ({ AuctionID, auctionName, laneName }) => {
  const {
    AuthStore: { memberName },
    DashboardStore: { auctionMetricList, connected },
    UIStore: { setHeaderText },
  } = useStores();
  // console.log('proxyBids > AdminLayout', { memberName, auctionName, laneName, AuctionID })

  // const auctionID = props.AuctionID;
  const items = [
    dashboardBreadcrumb,
    { to: '/auctions', label: 'Auctions' },
    {
      // to: '/auction/' + AuctionID + '/ProxyBids',
      label: 'Proxy Bids',
    },
  ];

  const getAuctionAndLaneName = () => {
    if (!laneName) return auctionName;
    return `${auctionName} - ${laneName}`;
  };
  const auctionAndLaneName = getAuctionAndLaneName();

  useEffect(() => {
    setHeaderText(auctionAndLaneName);
  }, []);

  return (
    <Layout>
      <TopBarContainer
        auctionAndLaneName={auctionName}
        connected={connected}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={{ pathname: to, state: { auctionName } }}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>
      </PageNavContainer>
      <MainContainer>
        <ProxyBidsHome
          laneName={laneName}
          auctionName={auctionName}
          AuctionID={AuctionID}
        />
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
